import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: calc(100vh - 400px);
`;

export const AnimatedText = styled.div`
  background-image: linear-gradient(90deg, #003bff, #00afff, #00d1c3);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  background-size: 200% 200%;
  animation: Animation 4s ease infinite;

  @keyframes Animation {
    0% {
      background-position: 10% 0;
    }
    50% {
      background-position: 91% 100%;
    }
    100% {
      background-position: 10% 0;
    }
  }
`;

export const Button = styled.div`
  background: ${({ theme }) => theme.bg.general};
  padding: 9px 18px;
  border-radius: 999px;
  cursor: pointer;

  &:hover {
    filter: brightness(1.05);
  }
`;
